__turbopack_context__.v({
  "badge": "Q6Epgq_badge",
  "closeButton": "Q6Epgq_closeButton",
  "invalid": "Q6Epgq_invalid",
});
